import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCoffee } = FiIcons;

const Preloader = () => {
  const { t } = useTranslation();

  const coffeeBeanVariants = {
    animate: i => ({
      y: [0, -30, 0], // More pronounced float
      opacity: [0.7, 1, 0.7],
      scale: [1, 1.3, 1], // Larger scale change
      rotate: [0, 360],
      transition: {
        duration: 2.5 + i * 0.3, // Faster, more striking animation
        repeat: Infinity,
        ease: "easeInOut",
        delay: i * 0.15
      }
    })
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gray-900 text-white" // Dark background
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative flex flex-col items-center justify-center p-10 rounded-lg bg-gray-800 border-4 border-lime-400 shadow-2xl shadow-lime-500/50" // Neobrutalist container
      >
        <div className="flex items-center mb-6 space-x-6"> {/* Container for both logos */}
          {/* Bondeega Logo */}
          <img
            src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759845307731-logo%20adjusted.png"
            alt="Bondeega Coffee Logo"
            className="w-24 h-24 object-contain border-2 border-white p-1 bg-white" // Strong border, white background for logo
          />
          {/* Separator */}
          <div className="w-1 h-20 bg-lime-400 rounded-full"></div> {/* Striking separator */}
          {/* Next Supply Logo */}
          <img
            src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759920909971-NEXT%20SUPPLY%20PNG.png"
            alt="Next Supply Trading & Distribution Logo"
            className="w-24 h-24 object-contain border-2 border-white p-1 bg-white" // Strong border, white background for logo
          />
        </div>
        
        <h1 className="text-5xl font-black text-lime-400 mb-3 tracking-wide">Bondeega</h1> {/* Bold, striking text */}
        <p className="text-xl text-gray-200 font-medium">{t('preloader.loading')}</p>

        {/* Animated Coffee Beans - adjust styling for neobrutalism */}
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            custom={i}
            variants={coffeeBeanVariants}
            initial="initial"
            animate="animate"
            className="absolute text-lime-300 opacity-80" // Brighter, more opaque beans
            style={{
              top: `${15 + i * 15}%`,
              left: `${5 + i * 18}%`,
              width: `${25 + i * 5}px`,
              height: `${25 + i * 5}px`,
            }}
          >
            <SafeIcon icon={FiCoffee} className="w-full h-full" />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Preloader;